import React, { 
  // lazy, Suspense, 
  // useEffect
 } from "react";
// import { Link, Outlet, useLocation } from "react-router-dom";
import MiniDrawer from "./components/MiniDrawer";
import GuidedTourRunning from "./components/GuidedTourRunning";
// import Sidebar from "./components/Sidebar";

// const LazyFooter = lazy(() => import("./components/MiniFooter"));

/* GuidedTourRunning sits here rather than inside MiniDrawer so it is on
   every authenticated page regardless of what that page draws: a tour the
   host left running is true of the product, not of one screen. */
const Layout = () => {
  return (
    <>
      <MiniDrawer>

      </MiniDrawer>
      <GuidedTourRunning />
    </>
  )
}

// const Layout = () => {
//   const { pathname } = useLocation();

//   // Reset scroll to top on route change
//   useEffect(() => {
//     window.scrollTo(0, 0);
//     // console.log("tested");
//   }, [pathname]);

//   return (
//     <div className="container max-w-screen-2xl flex bg-[#F6F6F8]  min-h-screen overflow-y-auto">
//       <div>
//         <MiniDrawer />
//       </div>
//       <div className="flex flex-col w-full h-[calc(100vh-4rem)] overflow-y-auto">
//         <Outlet />
//         <div className="flex w-full py-6 flex-col lg:flex-row bg-[#202020] text-white lg:justify-center gap-6 px-2 opacity-85">
//           <div className="  lg:text-right">
//             <Link to="/privacy_policy">Privacy Policy</Link>
//           </div>
//           <div className=" lg:text-right">
//             <Link to="/terms_and_conditions">Terms & Conditions</Link>
//           </div>
//           <div className=" lg:text-right">
//             <p>Copyright © 2025 Opensky. All rights reserved.</p>
//           </div>
//         </div>

//         {/* <Suspense fallback={null}>
//           <LazyFooter />
//         </Suspense> */}
//       </div>
//     </div>
//     // <>
//     //   <Sidebar />
//     //   {/* <Outlet /> */}
//     //   {/* <Suspense fallback={null}>
//     //            <LazyFooter />
//     //         </Suspense> */}
//     // </>
//     // <div className="container max-w-screen-2xl flex bg-[#F6F6F8] ">
//     //   {/* <div className=""> */}
//     //   <MiniDrawer />
//     //   {/* </div> */}
//     //   <div className="flex flex-col w-full h-screen ">
//     //     {/* <div className="flex flex-col h-screen"> */}
//     //     {/* Scrollable content area */}
//     //     <div className="flex-1 overflow-y-auto">
//     //       <Outlet />

//     //       {/* <div>
//     //         <Suspense fallback={null}>
//     //           <LazyFooter />
//     //         </Suspense>
//     //       </div> */}
//     //     </div>

//     //     {/* Mini Footer */}

//     //     {/* </div> */}
//     //   </div>
//     // </div>
//   );
// };

export default Layout;
